import { Box } from "@mui/material";
import React from "react";
import { usePlanContext } from "../auth/planProvider/PlanProvider.tsx";
import { useUrlProvider } from "../useUrlProvider.ts";
import { DotLegalHeader, DotLegalLink } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../localization/useTranslation.ts";

export interface AuditTemplateLinkWrapperProps {
    children: React.ReactNode;
}

function AuditTemplateLinkWrapper(props: AuditTemplateLinkWrapperProps) {
    const urlProvider = useUrlProvider();

    const { vendorManagementFeatures } = usePlanContext();
    const { translateString } = useTranslation();

    return (
        <>
            {props.children}
            {vendorManagementFeatures.hasVendorManagement && (
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <DotLegalHeader headerStyle={"extraSmall"} marginBottom={0} fontWeight={400}>
                        <DotLegalLink linkColor={"primary"} to={urlProvider.getAuditsUrl()}>
                            {translateString("createAuditTemplate")}
                        </DotLegalLink>
                    </DotLegalHeader>
                </Box>
            )}
        </>
    );
}

export default AuditTemplateLinkWrapper;
